<template>
<div class="container-fluid">
    <waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
    <div class="card">
    <div class="card-header text-white bg-primary">
        <h5><i class="fas fa-users mr-2" aria-hidden="true"></i>
            LISTA UTENTI 
    </h5>
        
  </div>
  <div class="card-body">
    <div class="row">
    <div class="col-sm"></div> 
    <div class="col-sm"> 
    <div v-if="type=='A'">
    
    <div class="table-wrapper-scroll-y my-custom-scrollbar table-responsive-sm">     
        <table class="table table-sm table-hover table-striped table-bordered">
        <thead >
            <tr>
            <th>
                Utente
            </th>
        
            <th>
                
            </th>
            
            </tr>
            </thead>
        <tbody>
            <tr v-for="(item,index) in items" :key="index">
        
                
                <td >
                {{item.name}}
                </td>  

                <td >
                    <div class="dropdown">
                    <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-cogs mr-2" aria-hidden="true"></i>
                        OPZIONI
                    </button>
                    <div class="dropdown-menu ">
                    <a v-bind:class="{ disabled: item.isAdmin==1 }"   class="dropdown-item" @click="setUserMenu(item)" href="#">
                    <i style="color:brown" class="fas fa-tasks mr-2" aria-hidden="true"></i>
                        Configura Menu</a>
                    <a v-bind:class="{ disabled: item.isAdmin==1 || item.isAdmin == 0 }" class="dropdown-item" @click="setUserStore(item)" href="#">
                    <i style="color:darkgreen" class="fas fa-store-alt mr-2" aria-hidden="true"></i>
                        Configura accesso a Sede </a>
                        <a v-bind:class="{ disabled: item.isAdmin==1 || item.isAdmin == 0 }" class="dropdown-item" @click="resetPassword(item)" href="#">
                    <i style="color:darkmagenta" class="fas fa-key mr-2" aria-hidden="true"></i>
                        Reset password </a>
                    </div>
                    </div>
                </td>  
        
            </tr>
        </tbody>
  </table>
  </div>  
  
  </div>
  <div v-else-if="type=='B'" >
    <user-menu @close="type='A'"  :user="user"></user-menu>
  </div>
    <div v-else-if="type=='C'" >  
  </div>  

  </div>
  <div class="col-sm"></div>
  </div>
  <!-- CARD  BODY-->
  </div>
</div>

</div> 

</template>
<script>

import api               from "@/api"
import { mapGetters }    from 'vuex';
import UserMenu          from "@/components/admin/UserMenu.vue"
import waitingModal      from "@/components/common/WaitingModal.vue"

export default {
   //props : {item:Object},
components :{UserMenu,waitingModal},
  

  data () {
    return {      
    
      items   : [],
      type    : 'A',
      user    : {},

      spinner : false,
      msg     : {title       : ''},
      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'ELABORAZIONE IN CORSO ...',
        msg2       : '' 

      },

    }
  },
  computed: 
  {  
    ...mapGetters(['company']), 
  },
   
  mounted()
    {
        //document.getElementById("id_0").focus();
    },
  created()
  {
      
    this.getData()
      //this.rows = JSON.parse(this.product.data)
      
  },
  methods: 
  {
   closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },  
   setUserMenu(item)
   {
    this.user.userId = item.userId
    this.user.userName = item.name
    this.type = 'B'
   },
   setUserStore()
   {

   },
   resetPassWord()
   {

   },
   async  getData()
    {
      const sp    = {'sp':'spCompanyUsersList'}
      const data  = {'companyId' : this.company.Id}
     
      const json  = Object.assign(data, sp);
      this.waitModal.show = true
      await api.post(json).then(res => {
        if(res.status==200)
          {
             this.waitModal.sentinel = 1 
            this.items =  res.data.recordsets[0]         
          }
          else if(res.status==500)
          {
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '                       
            this.msg.body = res
            this.msg.type = 1                
          } 
      }).catch(err => 
      {
        this.waitModal.sentinel = 3
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1           
      }).finally(() => {
        //this.spinner = false
      });

    },
    


    
  
  }
    
    
  
}

</script>

<style scoped>


.item {
  cursor: pointer;
}

.table thead tr:nth-child(1) th
{

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : brown;
    color        : white;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
.my-custom-scrollbar {
    position   : relative;
    height     : 400px;
    overflow   : auto;
}


</style>